<template>
  <div>
    <el-row style="height: 60px; line-height: 60px">
      <el-col :span="12" style="text-align: left; font-size: 20px; color: #0a666b">
        <span class="el-icon-chat-line-square" style="font-size: 22px"></span>
        {{ $t('preprint.pendingCommentTitle') }}
      </el-col>
    </el-row>

    <el-row v-if="commentList.length == 0">
      <el-col :span="24">
        <el-empty
          :description="$t('preprint.pendingCommentEmpty')"
          style="height: 900px; background-color: white"
        ></el-empty>
      </el-col>
    </el-row>

    <el-row style="min-height: 900px">
      <el-col :span="24" style="margin-top: 10px">
        <el-card
          class="box-card"
          shadow="hover"
          v-for="(item, index) in commentList"
          :key="index"
        >
          <div slot="header" class="clearfix">
            <span style="color: #0a666b; font-weight: 900; float: left">
              {{ $t('preprint.pendingCommentOn') }}: {{ item.preprintTitle || $t('preprint.menu') }}
            </span>
            <el-tag type="warning" size="small" style="float: right">
              {{ $t('preprint.myStatusPending') }}
            </el-tag>
          </div>
          <el-row>
            <el-col :span="18">
              <div style="margin-bottom: 10px; line-height: 1.6">
                <span style="color: #606266">{{ item.commentContent }}</span>
              </div>
              <div style="font-size: 12px; color: #909399">
                <span>{{ $t('preprint.pendingCommentUser') }}: {{ item.commenterName }} ({{ item.commenterEmail }})</span>
                <span style="margin-left: 20px">{{ $t('preprint.pendingCommentTime') }}: {{ item.commentTime }}</span>
              </div>
            </el-col>
            <el-col :span="6" style="text-align: right">
              <el-button
                size="small"
                type="primary"
                @click="viewPreprint(item.preprintId)"
                style="background-color: #09666c; border: none; margin-bottom: 5px"
              >
                {{ $t('preprint.pendingCommentViewPreprint') }}
              </el-button>
              <br />
              <el-button
                size="small"
                type="success"
                @click="auditComment(item, true)"
                style="margin-bottom: 5px"
              >
                {{ $t('preprint.pendingCommentApprove') }}
              </el-button>
              <br />
              <el-button
                size="small"
                type="danger"
                @click="openRejectDialog(item)"
              >
                {{ $t('preprint.pendingCommentReject') }}
              </el-button>
            </el-col>
          </el-row>
        </el-card>

        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 驳回对话框 -->
    <el-dialog
      :title="$t('preprint.pendingCommentRejectDialogTitle')"
      :visible.sync="rejectDialogVisible"
      width="500px"
    >
      <el-form label-width="100px">
        <el-form-item :label="$t('preprint.pendingCommentRejectReason')" required>
          <el-input
            type="textarea"
            :rows="4"
            v-model="rejectReason"
            :placeholder="$t('preprint.pendingCommentRejectPlaceholder')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="rejectDialogVisible = false">{{ $t('preprint.pendingCommentDialogCancel') }}</el-button>
        <el-button
          type="danger"
          @click="submitReject"
          :loading="auditing"
        >
          {{ $t('preprint.pendingCommentDialogConfirmReject') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPendingCommentList, auditComment } from '@/api/preprint'

export default {
  name: 'pendingCommentList',
  data() {
    return {
      userInfo: null,
      commentList: [],
      currentPage: 1,
      pageSize: 10,
      pageTotal: 0,
      rejectDialogVisible: false,
      auditing: false,
      currentComment: null,
      rejectReason: ''
    }
  },
  methods: {
    viewPreprint(preprintId) {
      this.$router.push({
        name: 'preprintDetail',
        query: { id: preprintId }
      })
    },
    auditComment(item, approved) {
      this.auditing = true
      auditComment({
        userInfo: {
          email: this.userInfo.email
        },
        commentId: item.id,
        approved: approved,
        rejectReason: ''
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.$message.success(this.$t('preprint.pendingCommentApproveSuccess'))
          this.loadPendingList()
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.pendingCommentAuditFailed'))
        }
      }).catch((err) => {
        console.error('审核错误:', err)
        this.$message.error(this.$t('preprint.pendingCommentAuditFailed'))
      }).finally(() => {
        this.auditing = false
      })
    },
    openRejectDialog(item) {
      this.currentComment = item
      this.rejectReason = ''
      this.rejectDialogVisible = true
    },
    submitReject() {
      if (!this.rejectReason) {
        this.$message.warning(this.$t('preprint.pendingCommentNeedReason'))
        return
      }

      this.auditing = true
      auditComment({
        userInfo: {
          email: this.userInfo.email
        },
        commentId: this.currentComment.id,
        approved: false,
        rejectReason: this.rejectReason
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.$message.success(this.$t('preprint.pendingCommentRejectSuccess'))
          this.rejectDialogVisible = false
          this.loadPendingList()
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.pendingCommentAuditFailed'))
        }
      }).catch((err) => {
        console.error('审核错误:', err)
        this.$message.error(this.$t('preprint.pendingCommentAuditFailed'))
      }).finally(() => {
        this.auditing = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadPendingList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadPendingList()
    },
    loadPendingList() {
      getPendingCommentList({
        userInfo: {
          email: this.userInfo.email
        },
        current: this.currentPage,
        size: this.pageSize
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.commentList = res.data.result.records || []
          this.pageTotal = res.data.result.total || 0
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.pendingCommentLoadFailed'))
        }
      }).catch((err) => {
        console.error('加载待审核评论列表错误:', err)
        this.$message.error(this.$t('preprint.pendingCommentLoadFailed'))
      })
    }
  },
  mounted() {
    // 获取用户信息
    const userInfoStr = this.$cookie.getCookie('userInfo')
    
    if (!userInfoStr) {
      this.$message.error(this.$t('preprint.needLogin'))
      this.$router.push({ name: 'login' })
      return
    }
    
    // 如果是字符串，尝试解析
    if (typeof userInfoStr === 'string') {
      try {
        this.userInfo = JSON.parse(userInfoStr)
      } catch (e) {
        this.userInfo = userInfoStr
      }
    } else {
      this.userInfo = userInfoStr
    }
    
    // 检查是否是管理员
    if (this.userInfo.type !== '责任编辑') {
      this.$message.error(this.$t('preprint.noAuth'))
      this.$router.push({ name: 'index' })
      return
    }
    
    this.loadPendingList()
  }
}
</script>

<style scoped>
.box-card {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;
}

/* 卡片头部样式，确保标题完整显示 */
.clearfix {
  min-height: 40px;
  padding: 10px 0;
  line-height: 1.5;
  overflow: visible;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}
</style>




// WEBPACK FOOTER //
// src/view/preprint/admin/pendingCommentList.vue